import React from 'react';
import PropTypes from 'prop-types';

const FormGroupLabel = ({ value, className }) => (
  // FormGroupLabel
  <h4 className={className}>{value}</h4>
  // End FormGroupLabel
);

FormGroupLabel.propTypes = {
  value: PropTypes.string.isRequired,
  className: PropTypes.string,
};

FormGroupLabel.defaultProps = {
  className: '',
};

export default FormGroupLabel;
